// Registro de novidades por versão, exibido ao usuário como uma linha do
// tempo "novidades" na primeira vez que ele abre a ferramenta após uma
// atualização (ver ChangelogModal em App.jsx).
//
// Curadoria manual: cada item é escrito em linguagem de usuário, não gerado
// a partir de commits. Adicione uma entrada no TOPO do histórico a cada
// release com novidade relevante para quem usa a ferramenta — e mantenha
// CHANGELOG_VERSAO_ATUAL igual à versão da entrada mais recente para o
// modal aparecer.

export const CHANGELOG_VERSAO_ATUAL = 'v2.2';

export const CHANGELOG_HISTORICO = [
  {
    versao: 'v2.2',
    data: '08/09/2026',
    itens: [
      'Campo de busca adicionado na aba Grupos, para filtrar por nome.',
    ],
  },
];
